import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BTechITCoursePage: React.FC = () => {
  const courseData = {
    title: "B.Tech. Information Technology",
    shortName: "B.Tech IT",
    duration: "4 years",
    description: "Comprehensive technology program focusing on software development, networking, and IT infrastructure management",
    overview: "Bachelor of Technology in Information Technology (B.Tech IT) is a 4-year undergraduate engineering program that focuses on the application of computing and telecommunications equipment to store, retrieve, transmit, and manipulate data. The course covers software development, database management, networking, cybersecurity, and emerging technologies like cloud computing and artificial intelligence.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores",
      "Age: Maximum 25 years (30 for SC/ST)"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Programming Fundamentals",
          "Computer Organization",
          "Digital Logic Design"
        ]
      },
      {
        year: 2,
        subjects: [
          "Data Structures & Algorithms",
          "Object-Oriented Programming",
          "Database Management Systems",
          "Computer Networks",
          "Software Engineering",
          "Operating Systems"
        ]
      },
      {
        year: 3,
        subjects: [
          "Web Technologies",
          "Mobile Application Development",
          "Cybersecurity",
          "Cloud Computing",
          "Artificial Intelligence",
          "Machine Learning"
        ]
      },
      {
        year: 4,
        subjects: [
          "Advanced Database Systems",
          "Network Security",
          "IoT & Embedded Systems",
          "Project Management",
          "Capstone Project",
          "Industrial Training"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Software Developer",
        "Web Developer",
        "Mobile App Developer",
        "Database Administrator",
        "Network Engineer",
        "Cybersecurity Analyst",
        "Cloud Solutions Architect",
        "IT Consultant",
        "System Administrator",
        "DevOps Engineer"
      ],
      industries: [
        "Information Technology",
        "Software Development",
        "Telecommunications",
        "Banking & Finance",
        "E-commerce",
        "Healthcare IT",
        "Government Sector",
        "Startups",
        "Consulting Services",
        "Cloud Service Providers"
      ],
      averageSalary: "₹4-15 LPA",
      topRecruiters: [
        "TCS",
        "Infosys",
        "Wipro",
        "Accenture",
        "Microsoft",
        "Google",
        "Amazon",
        "IBM",
        "Cognizant",
        "HCL Technologies"
      ]
    },

    topColleges: [
      {
        name: "Indian Institute of Technology (IIT) Delhi",
        location: "New Delhi",
        fees: "₹2,50,000/year",
        ranking: "1"
      },
      {
        name: "National Institute of Technology (NIT) Warangal",
        location: "Telangana",
        fees: "₹1,50,000/year",
        ranking: "2"
      },
      {
        name: "Delhi Technological University",
        location: "Delhi",
        fees: "₹1,20,000/year",
        ranking: "3"
      },
      {
        name: "Vellore Institute of Technology",
        location: "Tamil Nadu",
        fees: "₹1,98,000/year",
        ranking: "4"
      },
      {
        name: "SRM Institute of Science & Technology",
        location: "Tamil Nadu",
        fees: "₹2,50,000/year",
        ranking: "5"
      }
    ],

    skills: [
      "Programming Languages (Java, Python, C++)",
      "Web Development (HTML, CSS, JavaScript)",
      "Database Management",
      "Network Configuration",
      "Cybersecurity Fundamentals",
      "Cloud Platforms (AWS, Azure)",
      "Mobile App Development",
      "Software Testing",
      "Project Management",
      "Problem-Solving"
    ],

    futureScope: "B.Tech IT graduates have excellent prospects in the rapidly evolving technology sector. Career opportunities include software development, cybersecurity, cloud computing, artificial intelligence, data analytics, and IT management. With digital transformation across industries, the demand for IT professionals continues to grow globally, offering opportunities for higher studies, research, entrepreneurship, and international careers.",

    faqs: [
      {
        question: "What is the difference between B.Tech IT and B.Tech CSE?",
        answer: "B.Tech IT focuses more on practical applications of technology, networking, and IT infrastructure, while B.Tech CSE emphasizes computer science theory, algorithms, and software development fundamentals."
      },
      {
        question: "What are the job prospects after B.Tech IT?",
        answer: "Graduates can work as software developers, network engineers, database administrators, cybersecurity analysts, and IT consultants in various industries with excellent salary packages."
      },
      {
        question: "Can I pursue higher studies after B.Tech IT?",
        answer: "Yes, you can pursue M.Tech, MBA, MS abroad, or professional certifications in specialized areas like cybersecurity, cloud computing, or data science."
      },
      {
        question: "Is coding knowledge mandatory for B.Tech IT?",
        answer: "While prior coding knowledge is helpful, it's not mandatory. The curriculum starts with programming fundamentals and gradually builds advanced skills."
      },
      {
        question: "What are the top companies that hire B.Tech IT graduates?",
        answer: "Top recruiters include TCS, Infosys, Microsoft, Google, Amazon, Accenture, and many startups offering competitive packages."
      }
    ],

    admissionProcess: [
      "JEE Main Qualification",
      "State CET Examination (for state colleges)",
      "Choice Filling & Counseling",
      "Seat Allotment",
      "Document Verification",
      "Fee Payment & Admission Confirmation"
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0a183d] via-black to-[#1a2746] flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow animate-glow mb-8 text-center">
        {courseData.title}
      </h1>
      <div className="w-full max-w-5xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BTechITCoursePage;
